export const BOOKMARKBUTTON_TOGGLE_EVENT = "bookmarkbutton:toggle";
export const BOOKMARKLIST_LOADED_EVENT = "bookmarklist:loaded";
export const BREAKING_NEWS_GTM_EVENT = "breaking_news:gtm";
export const DRAWER_CLOSED_EVENT = "drawer:closed";
export const DRAWER_CLOSING_EVENT = "drawer:closing";
export const DRAWER_OPENED_EVENT = "drawer:opened";
export const DRAWER_OPENING_EVENT = "drawer:opening";
export const FETCH_FETCHED_EVENT = "fetch:fetched";
export const GALLERY_CHANGE_EVENT = "gallery:change";
export const GALLERY_PAYWALL_DIALOG_OPEN_EVENT = "gallery:open_paywall_dialog";
export const GTM_INIT_EVENT = "gtm:initialized";
export const MEDIA_INIT_EVENT = "media:initialized";
export const MESSAGE_HANDLER_ADRELOAD_EVENT = "messagehandler:adreload";
export const MESSAGE_HANDLER_INTERACTION_EVENT = "messagehandler:interaction";
export const ONBOARDINGPOPUP_SHOWN_EVENT = "onboardingpopup:shown";
export const ONBOARDINGPOPUP_CLOSED_EVENT = "onboardingpopup:closed";
export const PAYWALLCONTROL_OPENED_EVENT = "paywallcontrol:opened";
export const PAYWALL_CLICKED_EVENT = "paywall:clicked";
export const PAYWALL_VISIBLE_EVENT = "paywall:visible";
export const SHORTTEXTGALLERY_CHANGE_EVENT = "shortextgallery:change";
export const TEXTTOSPEECH_CLOSED_EVENT = "texttospeech:closed";
export const TEXTTOSPEECH_OPENED_EVENT = "texttospeech:opened";
export const ZEPHR_CUSTOM_DATA_REQUEST = "zephr:custom_data_request";
export const ZEPHR_DECISIONS_FINISHED_EVENT = "zephr.browserDecisionsFinished"; // DO NOT CHANGE THIS STRING, THIS IS A ZEPHR SDK EVENT
export const ZEPHR_DISABLED_EVENT = "zephr:disabled";
export const ZEPHR_ERROR_EVENT = "zephr:error";
export const ZEPHR_REGISTER_CUSTOM_DATA_EVENT = "zephr:register_custom_data";
export const ZEPHR_TIMEOUT_EVENT = "zephr:timeout";
